import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import reduxThunk, { ThunkMiddleware } from "redux-thunk";
import businessReducer from './businessReducer';

const bindMiddleware = (...middleware: any[]) => {
	return applyMiddleware(...middleware);
};

const rootReducer = combineReducers({
	business : businessReducer
});

  
export const store = createStore(
	rootReducer,
	compose(
	  bindMiddleware(
		reduxThunk as ThunkMiddleware
	  )
	)
);

